import React from "react";
import { container } from "@/utils/mobx";
import { SignInSectionStore } from "./store";
import { TextInput } from "@/components/toolkit/TextInput";
import { t } from "@/i18n";
import "./s.sign_in_section.css";


export const SignInSection = container((props: {
    store: SignInSectionStore
}) => {
    const store = props.store;

    return (
        <div className="sign_in_section">
            <div className="sign_in_section__form">
                <TextInput
                    className="sign_in_section__input"
                    type="email"
                    placeholder={t("sign_in_email")}
                    value={store.email}
                    onChange={(v) => store.setEmail(v)}
                    disabled={store.isLoading}
                />
                <TextInput
                    className="sign_in_section__input"
                    password
                    placeholder={t("sign_in_password")}
                    value={store.password}
                    onChange={(v) => store.setPassword(v)}
                    onEnter={() => store.submit()}
                    disabled={store.isLoading}
                />
                {store.error && (
                    <div className="sign_in_section__error">{store.error}</div>
                )}
                <button
                    className="sign_in_section__button"
                    onClick={() => store.submit()}
                    disabled={store.isLoading}
                >
                    {store.isLoading ? t("sign_in_submitting") : t("sign_in_submit")}
                </button>
            </div>
        </div>
    );
}, SignInSectionStore);
